"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var result_exports = {};
__export(result_exports, {
  QueryResult: () => QueryResult
});
module.exports = __toCommonJS(result_exports);
class QueryResult {
  constructor(messages, getId) {
    this.getId = getId;
    this.objectById = new Map(messages.map((it) => [getId(it), it]));
  }
  static {
    __name(this, "QueryResult");
  }
  objectById;
  total = -1;
  tail = false;
  head = false;
  get length() {
    return this.objectById.size;
  }
  setTotal(total) {
    this.total = total;
  }
  getTotal() {
    return Math.max(this.total, 0);
  }
  isTail() {
    return this.tail;
  }
  isHead() {
    return this.head;
  }
  setHead(head) {
    this.head = head;
  }
  setTail(tail) {
    this.tail = tail;
  }
  getResult() {
    return Array.from(this.objectById.values());
  }
  get(id) {
    return this.objectById.get(id);
  }
  delete(id) {
    const object = this.objectById.get(id);
    this.objectById.delete(id);
    return object;
  }
  deleteAll() {
    this.objectById.clear();
  }
  push(object) {
    this.objectById.set(this.getId(object), object);
  }
  unshift(object) {
    this.objectById = new Map([[this.getId(object), object], ...this.objectById]);
  }
  pop() {
    const array = Array.from(this.objectById.values());
    const last = array[array.length - 1];
    if (last === void 0) return;
    this.objectById.delete(this.getId(last));
    return last;
  }
  shift() {
    const array = Array.from(this.objectById.values());
    const first = array[0];
    if (first === void 0) return;
    this.objectById.delete(this.getId(first));
    return first;
  }
  update(object) {
    this.objectById.set(this.getId(object), object);
  }
  getFirst() {
    return Array.from(this.objectById.values())[0];
  }
  getLast() {
    return Array.from(this.objectById.values())[this.objectById.size - 1];
  }
  prepend(objects) {
    const current = Array.from(this.objectById.entries());
    this.objectById = new Map([...objects.map((object) => [this.getId(object), object]), ...current]);
  }
  append(objects) {
    for (const object of objects) {
      this.objectById.set(this.getId(object), object);
    }
  }
  sort(compare) {
    const current = Array.from(this.objectById.values());
    const sorted = current.sort(compare);
    this.objectById = new Map(sorted.map((object) => [this.getId(object), object]));
  }
  copy() {
    const copy = new QueryResult(Array.from(this.objectById.values()), this.getId);
    copy.setHead(this.head);
    copy.setTail(this.tail);
    return copy;
  }
}
//# sourceMappingURL=result.js.map
